import HttpService from "../baseHttp";

// 费率
export const HttpGetFinanceList = (data = {}, config) => HttpService.get('/api/v1/financeRates/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })

// 列表
export const HttpGetProductsList = (data = {}, config) => HttpService.get('/api/v1/Product/findByPage', { params: data })
// 新增/编辑 产品
export const HttpSaveProducts = (data = {}, config) => HttpService.post('/api/v1/Product/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 查看产品
export const HttpGetProductsOne = (data = {}, config) => HttpService.get('/api/v1/Product/getById', { params: data })


// 下载模板
export const HttpGetImport = (data = {}, config) => HttpService.get('/api/v1/Product/excel', { params: data })
// 导入模板
export const HttpSaveImport = (data = {}, config) => HttpService.post('/api/v1/Product/import', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })


// 按查询条件导出
export const HttpGetExport = (data = {}, config) => HttpService.get('/api/v1/Product/export', { params: data })

// 批量增加标签
export const HttpAddIcons = (data = {}, config) => HttpService.get('/api/v1/Product/batch/label', { params: data })

// 批量停用产品
export const HttpCancelIcons = (data = {}, config) => HttpService.get('/api/v1/Product/batch/cancel', { params: data })

// 批量修改补货
export const HttpBatchReplenishment = (data = {}, config) => HttpService.get('/api/v1/Product/batch/status', { params: data })

// 获取标签列表
export const HttpGetIconList = (data = {}, config) => HttpService.get('/api/v1/ProductLabel/findAllByContextId', { params: data })

// 新增/编辑标签列表
export const HttpSaveIconOne = (data = {}, config) => HttpService.get('/api/v1/ProductLabel/save', { params: data })

// 删除标签
export const HttpDeleteIconOne = (data = {}, config) => HttpService.get('/api/v1/ProductLabel/delete', { params: data })
// 获取品类
export const HttpGetCategories = (data = {}, config) => HttpService.get('/api/v1/Categories/findAll', { params: data })

// 获取币种，币种汇率的下拉
export const HttpGetCurrency = (data = {}, config) => HttpService.get('/api/v2/financeCurrency/getAllCurrencyAndRate', { params: data })

// 根据长宽高获取产品size
export const HttpGetProductSize = (data = {}, config) => HttpService.get('/api/v1/Product/getProductSize', { params: data })


// 库存明细查询
export const HttpGetInventoryList = (data = {}) => HttpService.post("/api/v2/inventory/list/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 查询产品币种
export const HttpGetfindCurrency = (data = {}, config) => HttpService.get('/api/v1/Product/findCurrency', { params: data })

// 编辑fob的保存
export const HttpSaveCurrency = (data = {}) => HttpService.post("/api/v1/Product/setCurrency", data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 点击转换汇率请求的接口
export const HttpGetCurrencyRate = (data = {}, config) => HttpService.post('/api/v1/Product/financeNewRate', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 查询销售定位的接口
export const HttpGetSaleLocation = (data = {}, config) => HttpService.get('/api/v1/Product/findAllSaleLocationInOrgId', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 推送仓库
export const HttpPushWarehouse = (data = {}) => HttpService.post("/api/v1/Product/batch/pushHouse", data, { baseURL: process.env.VUE_APP_APIURL_BOSS });

// 获取计算成本默认值
export const HttpGetComputCost = (data = {}) => HttpService.get('/api/v1/OrganizationOption/getOptionValueByName?keyword=cost', data, { params: { contextId: global.SYSID } });

// 获取组织配置
export const HttpGetOrgConfig = (data = {}) => HttpService.get('/api/v1/Organization/getContextOptionByName?optionName=autogen_erpsku', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });

//包裹运费测算
export const HttpGetSku = (data = {}) => HttpService.post("/api/v2/product/getSkuInfo", data, { headers: {  }, baseURL: process.env.VUE_APP_APIURL_FBB });
